import { Component, Input, OnInit } from '@angular/core';
import { HeaderService } from '../header/shared/header.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
   // Recebe true quando o menu está em versão lateral (colapsado)
   @Input() isLateral = false;
   
  modulosIndex: any = [];
  selectedModule: any = null;

  constructor(private headerService: HeaderService,) { }

  ngOnInit(): void {
    this.CarregaMenu();
  }

  async CarregaMenu() {

    this.headerService.getUsuarioModuloFuncionalidades().subscribe(data => {

      this.modulosIndex = data.body;

    });


  }

    // Alterna a exibição do submenu do módulo clicado
    toggleModule(modulo: any): void {
      if (this.selectedModule === modulo) {
        this.selectedModule = null;
      } else {
        this.selectedModule = modulo;
      }
    }

}
